import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-950 text-white py-10">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          
          {/* Logo et description */}
          <div className="bg-gray-800 p-4 rounded-xl">
            <Link to="/">
              <h2 className="text-2xl font-bold text-blue-600">Lizay Tech</h2>
            </Link>
            <p className="mt-4 text-gray-400">
              Empowering your digital transformation with innovative solutions. 
            </p>
            <h3 className="mt-6 font-semibold">Follow Us</h3>
            <div className="flex space-x-4 mt-2">
              <a href="https://www.facebook.com" className="text-blue-600 hover:text-blue-700" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com" className="text-blue-600 hover:text-blue-700" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://www.twitter.com" className="text-blue-600 hover:text-blue-700" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
              <a href="https://www.linkedin.com" className="text-blue-600 hover:text-blue-700" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Plan du site */}
          <div>
            <h3 className="font-bold mb-4">Site Map</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/portfolio" className="hover:text-white">Portfolio</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          {/* Follow Us - simple links */}
          <div>
            <h3 className="font-bold mb-4">Follow Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="https://www.facebook.com" className="hover:text-white" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="https://www.instagram.com" className="hover:text-white" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://www.linkedin.com" className="hover:text-white" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              <li><a href="https://www.twitter.com" className="hover:text-white" target="_blank" rel="noopener noreferrer">X</a></li>
            </ul>
          </div>

          {/* Nos services */}
          <div>
            <h3 className="font-bold mb-4">Our Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/services#DigitalMarketing" className="hover:text-white">Digital Marketing</Link></li>
              <li><Link to="/services#WebDevelopment" className="hover:text-white">Web Development</Link></li>
              <li><Link to="/services#SEOServices" className="hover:text-white">SEO Services</Link></li>
              <li><Link to="/services#GraphicDesign" className="hover:text-white">Graphic Design</Link></li>
              <li><Link to="/services#MobileDevelopment" className="hover:text-white">Mobile Development</Link></li>
            </ul>
          </div>
        </div>

        {/* Bas de page */}
        <div className="mt-10 border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between text-gray-500 text-sm">
          <p>© 2024 Created by: <span className="text-blue-600">Lizay Technology</span></p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="/termOfUse" className="hover:text-white">Terms Of Use</Link>
            <span>|</span>
            <Link to="/privacyPolicy" className="hover:text-white">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
